import Modal from '../Modal/Modal';
import ModalBody from '../Modal/ModalBody';
import ModalFooter from '../Modal/ModalFooter';
import ModalHeader from '../Modal/ModalHeader';

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
export type { ModalProps } from '../Modal/Modal';
export type { ModalHeaderProps } from '../Modal/ModalHeader';
export type { ModalBodyProps } from '../Modal/ModalBody';
export type { ModalFooterProps } from '../Modal/ModalFooter';

export default Modal;
